import { motion } from "framer-motion";

const certificatesData = [
  {
    title: "Curriculum Vitae",
    description: "My current education, experience, projects, and technical skills.",
    src: "/certificates/KacperCV1.pdf",
    type: "CV",
  },
  {
    title: "Cisco Networking Essentials",
    description: "Core networking concepts, infrastructure, and communication protocols.",
    src: "/certificates/cisco.pdf",
    type: "Certificate",
  },
  {
    title: "LinkedIn Paper Prototyping",
    description: "Early-stage interface design and rapid product prototyping.",
    src: "/certificates/paperproto.pdf",
    type: "Certificate",
  },
  {
    title: "LinkedIn Creating Personas",
    description: "User research and persona development for digital products.",
    src: "/certificates/creatingP.pdf",
    type: "Certificate",
  },
];

const Certificates = ({ embedded = false }) => {
  return (
    <section
      id="certificates"
      className={`scroll-mt-20 border-t border-zinc-200 bg-zinc-50 px-6 sm:px-10 lg:px-16 ${
        embedded ? "py-24 lg:py-32" : "min-h-screen py-20"
      }`}
    >
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-indigo-600">
            CV and certificates
          </p>

          <h2 className="mt-4 text-4xl font-semibold tracking-tight text-zinc-950 sm:text-5xl">
            Education and professional development
          </h2>

          <p className="mt-6 text-lg leading-8 text-zinc-600">
            View my current CV and selected certificates covering networking,
            design, and software-related skills.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {certificatesData.map((certificate, index) => (
            <motion.article
              key={certificate.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
              whileHover={{ y: -5 }}
              className="group flex flex-col rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm transition-shadow hover:shadow-lg"
            >
              <div className="flex items-start justify-between gap-5">
                <div>
                  <span className="inline-flex rounded-full bg-indigo-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-indigo-700">
                    {certificate.type}
                  </span>

                  <h3 className="mt-4 text-2xl font-semibold text-zinc-950">
                    {certificate.title}
                  </h3>

                  <p className="mt-3 leading-7 text-zinc-600">
                    {certificate.description}
                  </p>
                </div>

                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-zinc-100 text-zinc-700 transition group-hover:bg-zinc-950 group-hover:text-white">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M14 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V9M14 3L20 9M14 3V9H20"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              <div className="mt-auto pt-7">
                <a
                  href={certificate.src}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-xl bg-zinc-950 px-5 py-3 font-semibold text-white transition hover:bg-zinc-800"
                >
                  {certificate.type === "CV" ? "View CV" : "View certificate"}

                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M7 17L17 7M17 7H9M17 7V15"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificates;